import RegisterExperiment from '../Experiment/RegisterExperiment';
import registerBcidWithAltIdExperiment from './betaExperiments/registerBcidWithAltIdExperiment';
import { BCID_WITH_ALT_ID_EXPERIMENT_TYPE } from './betaExperiments/constants';

const RegisterBetaExperiment = async (props, updateExperiment) => {
  const {
    betaExperimentType
  } = props;
  if (betaExperimentType === BCID_WITH_ALT_ID_EXPERIMENT_TYPE) {
    return registerBcidWithAltIdExperiment(props, updateExperiment);
  }
  return RegisterExperiment(props, updateExperiment);
};

export default RegisterBetaExperiment;
